export default __webpack_public_path__ + "static/media/jp.8df20b88.svg";